import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useOrg } from '../contexts/OrgContext';
import { extractOrgIdFromPath } from '../utils/organizationUtils';

/**
 * Component that watches for location changes and updates organization context
 * This component must be used inside a Router context
 */
const OrganizationLocationWatcher: React.FC = () => {
  const location = useLocation();
  const { currentOrganization, loadOrganizationByUrl } = useOrg();

  useEffect(() => {
    const orgIdFromPath = extractOrgIdFromPath(location.pathname);
    
    if (orgIdFromPath && orgIdFromPath !== 'default') {
      // Only load if we don't already have this organization or if it's different
      if (!currentOrganization || currentOrganization.id !== orgIdFromPath) {
        console.log('🔄 Location changed, loading organization:', orgIdFromPath);
        loadOrganizationByUrl(orgIdFromPath);
      }
    }
  }, [location.pathname, currentOrganization, loadOrganizationByUrl]);

  // This component doesn't render anything
  return null;
};

export default OrganizationLocationWatcher;

